import { Button, makeStyles, TextField } from '@material-ui/core';
import React, { useEffect } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router';

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '22%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
});

export default function UpdateAsignature() {
  const classes = useStyles();
  const [name, setName] = React.useState('');
  const [selectedAsignature, setSelectedAsignature] = React.useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/asignatures/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data?.data) {
          setName(data?.data?.name);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleUpdate = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/asignatures/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name,
          }),
        }
      );

      let data = await response.json();
      if (data.success) {
        navigate('/admin/asignatures', { replace: true });
      } else {
        console.error(data.message);
        window.alert('Error al actualizar la asignatura, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar la asignatura, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, mediante este formulario usted podrá actualizar
        las asignaturas de la plataforma.
      </p>
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Nombre de la asignatura"
        variant="outlined"
        value={name || ''}
        onChange={(e) => setName(e.target.value)}
      />
      <Button
        onClick={() => {
          setSelectedAsignature(null);
          setName('');
        }}
      >
        Limpiar
      </Button>
      <div className={classes.formButtonsContainer}>
        <Button variant="contained" onClick={handleUpdate}>
          <AiFillEdit size={15} />
          Actualizar
        </Button>
      </div>
    </div>
  );
}
